var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49805 7.99854H20.498L18.998 21.4985H5.99805L4.49805 7.99854Z",
    stroke: "#151515",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00293 7.99951V5.99951C9.00293 5.07125 9.37168 4.18102 10.0281 3.52464C10.6844 2.86826 11.5747 2.49951 12.5029 2.49951C13.4312 2.49951 14.3214 2.86826 14.9778 3.52464C15.6342 4.18102 16.0029 5.07125 16.0029 5.99951V7.99951",
    stroke: "#151515",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartMenuIcon);
export default __webpack_public_path__ + "static/media/cart-menu-icon.72ee5c735608cfb2a200129c46f897ee.svg";
export { ForwardRef as ReactComponent };